import { CLASSES } from "@/scripts/helpers/constants";

export const initLoader = selector => {
  // Possible to have several loaders
  // If no selector passed on, find closest and use it globally
  const loader = selector || $("." + CLASSES.LOADER_WRAPPER);
  const loaderWrapper = loader.closest("." + CLASSES.LOADER_WRAPPER);

  if (loader.length) {
    if (!loaderWrapper.length) {
      $("body").addClass(CLASSES.LOADER_WRAPPER);
    }
    loader.addClass(CLASSES.IS_ACTIVE);
  }
};

export const hideLoader = () => {
  const loader = $("." + CLASSES.LOADER);
  const document = $("body");

  if (loader.hasClass(CLASSES.IS_ACTIVE)) {
    loader.removeClass(CLASSES.IS_ACTIVE);
  }

  if (document.hasClass(CLASSES.LOADER_WRAPPER)) {
    document.removeClass(CLASSES.LOADER_WRAPPER);
  }
};
